import React, { Component, PropTypes } from 'react';
import { default as TouchBackend } from 'react-dnd-touch-backend';
import { DragDropContext } from 'react-dnd';
import ScrollableContainer from 'Cio/ScrollableContainer';
import PageLayoutOverviewColumnPreview from './LayoutOverview/PageLayoutOverviewColumnPreview';
import PageLayoutOverviewRow from './LayoutOverview/PageLayoutOverviewRow';
import PageLayoutEditorToolbar from './LayoutOverview/PageLayoutEditorToolbar';
import { RaisedButton } from 'material-ui';
import { Units } from 'Css';
import { ThemeStore, CourseStore } from 'stores';
import { mixin, RefluxMixin } from 'Util';

const css = oxygenCss({
  addModuleButton: {
    marginTop: Units.keyline,
    padding: Units.base
  }
});

class PageLayoutEditor extends mixin(RefluxMixin, Component) {
  static propTypes = {
    closeLayoutEditor: PropTypes.func,
    openModuleMenu: PropTypes.func,
    layout: PropTypes.object
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  listenToStores() {
      this.listenToStoreWithMapper(CourseStore, state => {
          return {
              course: state.course,
              theme: state.course.theme
          };
      });
  }

  render() {
    const { layout, closeLayoutEditor, openModuleMenu } = this.props;
    const { getIntlMessage } = this.context;
    return (
      <ScrollableContainer
        padded
        header={
          <PageLayoutEditorToolbar closeLayoutEditor={closeLayoutEditor} />
        }
      >
        {layout.pageRows.map(pageRow => {
          const { id, ...other } = pageRow;
          return <PageLayoutOverviewRow id={id} key={id} {...other} />;
        })}
        <PageLayoutOverviewColumnPreview key="preview" name="CourseColumn" />
        <div className={css.addModuleButton}>
          <RaisedButton
            fullWidth
            backgroundColor={ThemeStore.getColor( this.state.theme.color )}
            label={getIntlMessage('pageModule.add')}
            secondary
            onTouchTap={openModuleMenu}
          />
        </div>
      </ScrollableContainer>
    );
  }
}

export default DragDropContext(TouchBackend({ enableMouseEvents: true }))(
  PageLayoutEditor
);



// WEBPACK FOOTER //
// ./src/js/components/Page/PageLayoutEditor.js